import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import DepositsList from './DepositsList';
import { Breadcrumbs } from '../../../AbstractElements';


const BasicTables = () => {
    return (
        <Fragment>
            <Breadcrumbs title="Deposits" mainTitle='' />
            <Container fluid={true}>
                <Row>
                    <DepositsList />
                </Row>
            </Container>
        </Fragment>
    );
};

export default BasicTables;